import localStrings from '@/localStrings.js'

let lang = navigator.language
let langCode = lang[0]+lang[1]

let content = localStrings['en']

if(langCode == 'zh'){
  content = localStrings['cn']
}

let contentManager = {
  content:content
};


export default contentManager